import React from 'react';
import NavMenu from './nav/navMenu';
import './style.scss';

const Header = () => <NavMenu />;

export default Header;
